<div class="content-header flex-row">
  <h1>{{ "Restricted access" | translate }}</h1>
</div>
<div class="margin-left50"> You do not have the required permission to access the requested page</div>
<div class="margin-left50"> Click <a class="clickable" (click)="navigateBack()">HERE</a> to return </div>
